 
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const GetAllocations = /* GraphQL */ `query GetAllocations(
  $maxRows: Int
  $orgId: String!
  $pageNumber: Int
  $searchStr: String
) {
  GetAllocations(
    maxRows: $maxRows
    orgId: $orgId
    pageNumber: $pageNumber
    searchStr: $searchStr
  ) {
    data {
      headers
      pagination {
        pageNumber
        pageSize
        totalRows
        __typename
      }
      rows
      __typename
    }
    message
    statusCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllocationsQueryVariables,
  APITypes.GetAllocationsQuery
>;
export const GetChart = /* GraphQL */ `query GetChart($chartId: String!, $orgId: String!) {
  GetChart(chartId: $chartId, orgId: $orgId) {
    athenaExecutionId
    chartId
    chartImageUrl
    chartType
    config
    createdAt
    createdBy
    dashboardIds
    description
    executionId
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetChartQueryVariables, APITypes.GetChartQuery>;
export const GetCharts = /* GraphQL */ `query GetCharts($orgId: String!) {
  GetCharts(orgId: $orgId) {
    athenaExecutionId
    chartId
    chartImageUrl
    chartType
    config
    createdAt
    createdBy
    dashboardIds
    description
    executionId
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetChartsQueryVariables, APITypes.GetChartsQuery>;
export const GetDashboard = /* GraphQL */ `query GetDashboard($dashboardId: String!, $orgId: String!) {
  GetDashboard(dashboardId: $dashboardId, orgId: $orgId) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardQueryVariables,
  APITypes.GetDashboardQuery
>;
export const GetDashboardNames = /* GraphQL */ `query GetDashboardNames($dashboardIds: [String!]!, $orgId: String!) {
  GetDashboardNames(dashboardIds: $dashboardIds, orgId: $orgId) {
    dashboardId
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardNamesQueryVariables,
  APITypes.GetDashboardNamesQuery
>;
export const GetDashboards = /* GraphQL */ `query GetDashboards($orgId: String!) {
  GetDashboards(orgId: $orgId) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardsQueryVariables,
  APITypes.GetDashboardsQuery
>;
export const GetHealth = /* GraphQL */ `query GetHealth {
  GetHealth {
    environment
    status
    timestamp
    version
    __typename
  }
}
` as GeneratedQuery<APITypes.GetHealthQueryVariables, APITypes.GetHealthQuery>;
export const GetMatchSchedule = /* GraphQL */ `query GetMatchSchedule($input: GetMatchScheduleInput!) {
  GetMatchSchedule(input: $input) {
    location
    market
    match_date
    match_id
    stadium
    status
    team_1
    team_1_code
    team_2
    team_2_code
    year
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMatchScheduleQueryVariables,
  APITypes.GetMatchScheduleQuery
>;
export const GetMetadata = /* GraphQL */ `query GetMetadata($source: String!) {
  GetMetadata(source: $source) {
    metadata {
      columns {
        description
        name
        type
        __typename
      }
      database_name
      datasource_name
      table_description
      table_name
      __typename
    }
    source
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMetadataQueryVariables,
  APITypes.GetMetadataQuery
>;
export const GetNotification = /* GraphQL */ `query GetNotification($input: GetNotificationInput!) {
  GetNotification(input: $input) {
    createdAt
    createdBy
    isRead
    notificationId
    orgId
    payload
    readAt
    username
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const GetPBDashboardConfig = /* GraphQL */ `query GetPBDashboardConfig($input: PBDashboardQueryInput!) {
  GetPBDashboardConfig(input: $input) {
    clubCode
    createdAt
    embedUrl
    groupId
    reportId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPBDashboardConfigQueryVariables,
  APITypes.GetPBDashboardConfigQuery
>;
export const GetPreSignedUrl = /* GraphQL */ `query GetPreSignedUrl($input: PreSignedUrl) {
  GetPreSignedUrl(input: $input) {
    deleteUrl
    error
    getUrl
    putUrl
    statusCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPreSignedUrlQueryVariables,
  APITypes.GetPreSignedUrlQuery
>;
export const GetQueryHistory = /* GraphQL */ `query GetQueryHistory($input: QueryHistoryInput!) {
  GetQueryHistory(input: $input) {
    athenaExecutionId
    createdAt
    createdBy
    description
    executedAt
    executedBy
    executionId
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    queryType
    schedulerName
    segmentedFanCount
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryHistoryQueryVariables,
  APITypes.GetQueryHistoryQuery
>;
export const GetQueryHistoryForChart = /* GraphQL */ `query GetQueryHistoryForChart($input: QueryHistoryInput!) {
  GetQueryHistoryForChart(input: $input) {
    athenaExecutionId
    createdBy
    executionId
    executionStatus
    lastModifiedAt
    metadata
    name
    orgId
    queryId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryHistoryForChartQueryVariables,
  APITypes.GetQueryHistoryForChartQuery
>;
export const GetQueryRecords = /* GraphQL */ `query GetQueryRecords($filterDropdownValue: Boolean, $orgId: String!) {
  GetQueryRecords(filterDropdownValue: $filterDropdownValue, orgId: $orgId) {
    createdAt
    createdBy
    description
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    query
    queryId
    queryType
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryRecordsQueryVariables,
  APITypes.GetQueryRecordsQuery
>;
export const GetQueryResult = /* GraphQL */ `query GetQueryResult($input: QueryResultInput) {
  GetQueryResult(input: $input) {
    data {
      headers
      pagination {
        pageNumber
        pageSize
        totalRows
        __typename
      }
      rows
      __typename
    }
    message
    statusCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryResultQueryVariables,
  APITypes.GetQueryResultQuery
>;
export const GetQuerySchedulers = /* GraphQL */ `query GetQuerySchedulers($orgId: String!) {
  GetQuerySchedulers(orgId: $orgId) {
    createdAt
    createdBy
    end {
      endAt
      maxOccurrences
      type
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    queryName
    queryType
    recurrence {
      frequency
      interval
      monthly {
        dayOfMonth
        dayOfWeek
        mode
        weekOfMonth
        __typename
      }
      weekly {
        days
        __typename
      }
      __typename
    }
    schedulerDescription
    schedulerId
    schedulerStatus
    startAt
    timezone
    type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuerySchedulersQueryVariables,
  APITypes.GetQuerySchedulersQuery
>;
export const GetQueryTemplates = /* GraphQL */ `query GetQueryTemplates($orgId: String!) {
  GetQueryTemplates(orgId: $orgId) {
    createdAt
    createdBy
    description
    filters {
      dependent
      displayName
      name
      parentFilterName
      values
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    query
    templateId
    templateType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryTemplatesQueryVariables,
  APITypes.GetQueryTemplatesQuery
>;
export const GetQueryWithExecutionRecords = /* GraphQL */ `query GetQueryWithExecutionRecords(
  $executionId: String!
  $orgId: String!
  $queryId: String!
) {
  GetQueryWithExecutionRecords(
    executionId: $executionId
    orgId: $orgId
    queryId: $queryId
  ) {
    athenaExecutionId
    createdAt
    createdBy
    executedAt
    executedBy
    executionDescription
    executionDuration
    executionId
    executionName
    executionSource
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    orgId
    query
    queryDescription
    queryId
    queryName
    schedulerId
    schedulerIds
    schedulerName
    segmentedFanCount
    selectedFilterConfig
    status
    templateId
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryWithExecutionRecordsQueryVariables,
  APITypes.GetQueryWithExecutionRecordsQuery
>;
export const GetResources = /* GraphQL */ `query GetResources($input: ResourceQueryInput!) {
  GetResources(input: $input) {
    createdAt
    description
    fileSize
    fileUrl
    groupId
    groupName
    orgId
    section
    title
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourcesQueryVariables,
  APITypes.GetResourcesQuery
>;
export const GetSchedulerNames = /* GraphQL */ `query GetSchedulerNames($orgId: String!, $schedulerIds: [String!]!) {
  GetSchedulerNames(orgId: $orgId, schedulerIds: $schedulerIds) {
    schedulerId
    schedulerName
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSchedulerNamesQueryVariables,
  APITypes.GetSchedulerNamesQuery
>;
